import { render } from "./dashboardShortcuts.vue?vue&type=template&id=66a2efe4"
import script from "./dashboardShortcuts.vue?vue&type=script&lang=js"
export * from "./dashboardShortcuts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__